import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function IconButton({ label, compact, className, type = "button", children, ...rest }) {
    return (_jsx("button", { type: type, "aria-label": label, className: cn("fwfa-icon-button", compact && "fwfa-button--compact", className), ...rest, children: children }));
}
//# sourceMappingURL=IconButton.js.map